export default __webpack_public_path__ + "static/media/upload.605b65d3.svg";